<template>
  <div>
    <anosafra-multiselect
      v-model="crop"
      label="Ano Safra"
      @input="notifyChange"
      @search-change="loadCrops"
    />
  </div>
</template>

<script>
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

export default {
  name: "crop-filter-select",
  components: {
    AnosafraMultiselect,
  },
  props: ["crop"],
  data() {
    return {
      crops: [],
    };
  },
  methods: {
    notifyChange(crop){
      this.$emit('selected', crop)
    }
  },
  mounted() {
    this.loadCrops();
  },
};
</script>
